import { __assign } from "tslib";
import React from 'react';
import { Button, ButtonGroup, Modal, Row } from 'react-bootstrap';
import ModalMain from './Main';
export default function ModalAccion(p) {
    var _a = p.isValid, isValid = _a === void 0 ? true : _a, close = p.close, msn = p.msn, accion = p.accion, _b = p.variant, variant = _b === void 0 ? 'warning' : _b;
    return React.createElement(ModalMain, __assign({}, p, { variant: variant }),
        React.createElement(Modal.Body, null,
            React.createElement(Row, { style: { padding: "10px 10px 10px 10px" }, dangerouslySetInnerHTML: { __html: msn } })),
        React.createElement(Modal.Footer, null,
            React.createElement(ButtonGroup, { className: "float-right" },
                isValid ? React.createElement(Button, { onClick: function () { accion(); close(); }, variant: "success" },
                    React.createElement("span", { className: "fa fa-check-circle-o" }),
                    " Aceptar") : React.createElement(React.Fragment, null),
                React.createElement(Button, { onClick: close, variant: "danger" },
                    React.createElement("span", { className: "fa fa-remove-circle" }),
                    " Cancelar"))));
}
//# sourceMappingURL=Accion.js.map